<template>
  <VDropdown
    ref="helpDropdown"
    :auto-hide="false"
    :distance="16"
    class="HelpTooltip"
    placement="right"
  >
    <span class="HelpTooltip__trigger">
      <slot>
        <span v-if="content()" class="HelpTooltip__question-mark">?</span>
      </slot>
    </span>

    <template #popper>
      <div
        class="help-tooltip-content"
        style="
          background: #fff4d9;
          color: black;
          padding: 24px;
          border-radius: 5px;
          box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.05);
          max-width: 350px;
        "
      >
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p class="text-left" v-html="content()" />
        <a class="HelpTooltip__button" @click="$refs.helpDropdown?.hide()">{{
          t('shared.close_tooltip')
        }}</a>
      </div>
    </template>
  </VDropdown>
</template>

<script>
import VueTypes from 'vue-types'
import { Dropdown as VDropdown } from 'floating-vue'
import tooltipText from '@/utils/tooltipText'
import danishTooltips from './tooltips_da'
import englishTooltips from './tooltips_en'
import germanTooltips from './tooltips_de'

export default {
  name: 'HelpTooltip',
  components: {
    VDropdown,
  },
  props: {
    tooltipKey: VueTypes.String,
  },

  methods: {
    content() {
      return tooltipText(this.tooltips(), this.tooltipKey)
    },
    tooltips() {
      switch (this.currentLocale()) {
        case 'da':
          return danishTooltips
        case 'en':
          return englishTooltips
        case 'de':
          return germanTooltips
      }
    },
  },
}
</script>

<style lang="scss">
@import 'style.scss';
</style>
